import { Flex } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
}

const ChainIndicatorsContainer = ({ children }: Props) => {
  return (
    <Flex
      px={{ base: 2, lg: 3 }}
      py={ 2 }
      borderRadius="base"
      bgColor={{ _light: 'theme.stats.bg._light', _dark: 'theme.stats.bg._dark' }}
      columnGap={ 2 }
      rowGap={ 0 }
      flexBasis="auto"
      flexGrow={ 0 }
      flexShrink={ 0 }
      alignItems="stretch"
      w="auto"
    >
      { children }
    </Flex>
  );
};

export default React.memo(ChainIndicatorsContainer);
